import { type FC } from "react"

import type { LandingPageGalleryBlock } from "@forento/core/models/landing"

type Props = {
	block: LandingPageGalleryBlock
}

const GalleryBlockPreview: FC<Props> = ({ block }) => {
	if (block.content.images.length === 0) return null

	return (
		<section className="px-6 pt-16 pb-0 sm:pt-20 lg:px-8">
			<div className="mx-auto max-w-7xl">
				{block.content.title && (
					<h2 className="text-landing-foreground mb-12 text-center text-3xl font-bold tracking-tight sm:text-4xl">
						{block.content.title}
					</h2>
				)}
				<div className="grid gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
					{block.content.images.map((image, index) => (
						<figure
							key={index}
							className="border-landing-border bg-landing-surface-muted relative overflow-hidden rounded-2xl border"
						>
							<div className="bg-landing-surface-muted relative aspect-video w-full overflow-hidden">
								<img
									src={image.url}
									alt={image.alt ?? image.label ?? ""}
									className="size-full object-cover"
								/>
							</div>
							{(image.label || image.alt) && (
								<figcaption className="flex items-center justify-between gap-2 px-4 py-3 text-sm">
									<span className="text-landing-foreground font-medium">{image.label}</span>
									{image.alt && !image.label && (
										<span className="text-landing-foreground-muted truncate">{image.alt}</span>
									)}
								</figcaption>
							)}
						</figure>
					))}
				</div>
			</div>
		</section>
	)
}

export default GalleryBlockPreview
